<template>
    <Deallist :onlyArchived="true" :showActionCol="true"></Deallist>
</template>

<script>
import Deallist from "@/views/Deallist/Deallist";

export default {
    name: "DeallistArchived",
    components: {Deallist}
}
</script>

<style scoped>

</style>